export default __webpack_public_path__ + "static/media/Japan_Particle_0013_TenkoBall_1.430aed32.png";